import React from "react";

import { getDateFormat } from "utils/tables/getDateFormat";
import { getDateSelector } from "utils/tables/getDateSelector";

import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { IconButton, Tooltip } from "@mui/material";

const stateIcons = {
  completed: <CheckCircleOutlineIcon color="success" size="small"/>,
  initiated: <CancelOutlinedIcon color="error" size="small"/>,
  pending: <PauseCircleOutlineIcon color="warning" size="small"/>,
}

const stateLabels = {
  completed: "Collected",
  initiated: "Not Collected",
  pending: "Pending",
}

const renderRedeemState = ( row ) => {
  return <Tooltip title={stateLabels[row.redeem_state]}>{stateIcons[row.redeem_state]}</Tooltip>
};

const renderSeeDetails = ( onClick ) => {
  return <Tooltip title="See Details"><IconButton onClick={onClick} size="small"><ZoomInIcon /></IconButton></Tooltip>
};

export const merchCollectionsColumns = ( handleOpenDetails ) => {
  return [
    {
      field: "redeem_state",
      name: "",
      sortable: true,
      width: "56px",
      style: { cursor: "default" },
      selector: (row) => renderRedeemState( row ),
    },
    {
      field: "details",
      name: "",
      width: "56px",
      allowOverflow: true,
      style: { cursor: "default" },
      selector: (row) => renderSeeDetails( () => handleOpenDetails(row) ),
    },
    {
      field: "email",
      name: "Email Address",
      sortable: true,
      width: "200px",
      style: { cursor: "default" },
      selector: (row) => row.user_email,
    },
    {
      field: "name",
      name: "Name",
      sortable: true,
      width: "200px",
      style: { cursor: "default" },
      selector: (row) => row.user_name,
    },
    {
      field: "title",
      name: "Product",
      sortable: true,
      width: "200px",
      style: { cursor: "default" },
      selector: (row) => row.variant_label ? `${row.title} — ${row.variant_label}` : row.title,
    },
    {
      field: "completed_at",
      name: "Collected",
      sortable: true,
      width: "150px",
      style: { cursor: "default" },
      selector: (row) => getDateSelector(row.completed_at),
      format: (row) => getDateFormat(row.completed_at, 'DD/MM HH:mm'),
    },
  ];
};
